<div class="d-flex" id="wrapper" [class.toggled]="toggledSidebar">
  <!-- Page Content -->
  <div id="page-content-wrapper">
    <div class="container-fluid container-fluid-mobile">
      <app-header (sidebarToggled)="onSidebarToggled()"></app-header>
      <div class="row">
        <main class="col-md-12 m-auto">
          <router-outlet></router-outlet>
        </main>
      </div>
    </div>
  </div>
  <!-- /#page-content-wrapper -->
</div>
